import React__default from 'react';
import { Button, Modal } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { pushSizeGuideLinkClickEvent, pushBookAppointmentClickEvent, pushVTOClickEvent } from '../../../Analytics/events/SizeGuideEvents.js';
import FindOutSize from './components/FindOutSize/FindOutSize.js';
import Measure from './components/Measure/Measure.js';
import SizeGuide from './components/SizeGuide/SizeGuide.js';

const SizeGuideModalView = ({ sizeGuideContent , productName , sku , isVtoEnabled ,  })=>{
    const { getLabel  } = useIntl();
    const [openModal, setOpenModal] = React__default.useState(false);
    if (!sizeGuideContent) {
        return null;
    }
    const { findOutSizeCTA , findOutSizeDescription , findOutSizeImage , findOutSizeSubtitle , findOutSizeTitle , measureDescription , measureDescriptionImage , measureImage , measureSteps , measureTitle , sizeGuideSizeCompound , sizeTitle ,  } = sizeGuideContent;
    const showVTOButton = !findOutSizeCTA && isVtoEnabled;
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement("div", {
        className: "size-guide-modal"
    }, /*#__PURE__*/ React__default.createElement("span", {
        className: "size-guide-modal__title"
    }, getLabel('products.frameSize.title')), /*#__PURE__*/ React__default.createElement(Button, {
        className: "size-guide-modal__trigger",
        variant: "ghost",
        size: "custom",
        caption: getLabel('products.frameSize.link'),
        onClick: ()=>{
            setOpenModal(true);
            pushSizeGuideLinkClickEvent(sku, productName);
        }
    })), openModal && /*#__PURE__*/ React__default.createElement(Modal, {
        className: "size-guide-modal__modal",
        isOpen: openModal,
        showIcon: true,
        onModalClose: ()=>setOpenModal(false)
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "size-guide-modal__modal-container"
    }, /*#__PURE__*/ React__default.createElement(SizeGuide, {
        sizeGuideSizeCompound: sizeGuideSizeCompound,
        sizeTitle: sizeTitle
    }), /*#__PURE__*/ React__default.createElement(Measure, {
        measureDescription: measureDescription,
        measureDescriptionImage: measureDescriptionImage,
        measureImage: measureImage,
        measureSteps: measureSteps,
        measureTitle: measureTitle
    }), /*#__PURE__*/ React__default.createElement(FindOutSize, {
        findOutSizeCTA: findOutSizeCTA,
        findOutSizeDescription: findOutSizeDescription,
        findOutSizeImage: findOutSizeImage,
        findOutSizeSubtitle: findOutSizeSubtitle,
        findOutSizeTitle: findOutSizeTitle,
        showVTOButton: showVTOButton,
        onVTOStart: ()=>setOpenModal(false)
        ,
        pushBookAppointmentClickEvent: ()=>pushBookAppointmentClickEvent(sku, productName)
        ,
        pushVTOClickEvent: ()=>pushVTOClickEvent(sku, productName)
    }))));
};

export { SizeGuideModalView };
//# sourceMappingURL=SizeGuideModalView.js.map
